import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '@/services/api/dashboard.service';
import { queryKeys } from './keys';

/**
 * The admin console's opening screen.
 *
 * `attention` is part of the key rather than a filter applied after fetching:
 * asking for four labs and asking for twenty are different responses, and
 * caching them under one key would serve whichever arrived first.
 */
export function usePortfolio(attention = 4) {
  return useQuery({
    queryKey: queryKeys.dashboard.summary(attention),
    queryFn: ({ signal }) => dashboardService.summary(attention, signal),
    /*
     * A minute. These numbers move when a NuDent administrator provisions a
     * lab or a technician activates a seat - human timescales - but somebody
     * who has just issued a licence looks straight back at this screen.
     */
    staleTime: 60_000,
  });
}
